import * as React from 'react';
import type { SVGProps } from 'react';
const SvgWrench = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M14.464 8.95a1 1 0 0 1 0-1.414l2.37-2.37a4.25 4.25 0 0 0-5.67 5.67l-6 6a1.414 1.414 0 1 0 2 2l6.001-6.001a4.25 4.25 0 0 0 5.68-5.648L16.48 9.55a1 1 0 0 1-1.414 0z"
    />
  </svg>
);
export default SvgWrench;
